import { Drawer } from '@talos/kyoko';
import { useRef } from 'react';
import { useAvaAIVisibility } from '../../providers/AvaAIContext';
import { AvaAIContent } from './AvaAIContent';
import { AVA_AI_WIDTH } from './tokens';

export function AvaAIDrawer() {
  const { isEnabled, isOpen, isPopped, open, close, popout } = useAvaAIVisibility();
  const isDrawerVisible = isEnabled && isOpen && !isPopped;
  const drawerRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  if (!isEnabled) {
    return null;
  }

  return (
    <Drawer
      isOpen={isDrawerVisible}
      open={open}
      close={close}
      position="relative"
      placement="right"
      width={AVA_AI_WIDTH}
      adjustForGapMargin={0}
      drawerRef={drawerRef}
      contentRef={contentRef}
    >
      {isDrawerVisible && <AvaAIContent onClose={close} onPopout={popout} />}
    </Drawer>
  );
}
